import { handleAPI, API_VERSION_ONE } from '../../../itrust_common/utils/apiUtils';

export function reportsLoad(filters) {
  const url = `/${API_VERSION_ONE}/reports`;
  const method = 'GET'

  return {
    type: 'REPORTS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function reportLoad(id, filters) {
  const url = `/${API_VERSION_ONE}/reports/${id}`;
  const method = "GET"
  return {
    type: 'REPORT_LOAD',
    payload: handleAPI(url, filters, method)
  }
}

export function reportCreate(data, filters) {
  const url = `/${API_VERSION_ONE}/reports/`;
  const method = 'POST'
  return {
    type: 'REPORT_CREATE',
    payload: handleAPI(url, filters, method, { report: { ...data } })
  }
}

export function reportUpdate(data, filters) {
  const url = `/${API_VERSION_ONE}/reports/${data.id}`;
  const method = "PUT"
  return {
    type: 'REPORT_UPDATE',
    payload: handleAPI(url, filters, method, { report: { ...data } })
  }
}

export function reportDelete(id, filters) {
  const url = `/${API_VERSION_ONE}/reports/${id}`;
  const method = "DELETE"
  return {
    type: 'REPORT_DELETE',
    payload: handleAPI(url, filters, method)
  }
}

export function reportEmailLoad(id, filters) {
  const url = `/${API_VERSION_ONE}/reports/${id}/email`;
  const method = 'GET'

  return {
    type: 'REPORT_EMAIL_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function reportFaxLoad(id, filters) {
  const url = `/${API_VERSION_ONE}/reports/${id}/fax_pdf`;
  const method = 'GET'

  return {
    type: 'REPORT_FAX_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function reportPreviewLoad(id, filters) {
  const url = `/${API_VERSION_ONE}/reports/${id}/preview`;
  const method = 'GET'

  return {
    type: 'REPORT_PREVIEW_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function reportEdit(data) {
  return {
    type: 'REPORT_EDIT',
    payload: data,
  };
}

export function reportReset() {
  return {
    type: 'REPORT_RESET'
  };
}